import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { MovieOrderModel } from "@/api/user/user.types";
import { cn } from "@/utils/cn.ts";

const OrderMovieTable = ({ className, orders }: { className?: string; orders: MovieOrderModel[] }): JSX.Element => {
  const { t } = useTranslation();

  const formateDate = (dateString: string) => {
    const date = new Date(dateString);

    return date.toLocaleDateString("ru", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className={cn("relative overflow-x-auto", className)}>
      <div className={"text-on-surface grid grid-cols-10 gap-1 pb-4"}>
        <p className={"col-span-3"}>{t("Orders.date")}</p>
        <p className={"col-span-3"}>{t("General.name")}</p>
        <p className={"col-span-3"}>{t("General.description")}</p>
        <p className={"col-span-1"}>{t("General.status")}</p>
      </div>
      {orders.map((item) => (
        <div key={item.id} className={"border-t-surface-container grid grid-cols-10 gap-2 border-t py-4"}>
          <p className={"col-span-3"}>{formateDate(item.updated_at)}</p>
          <p className={"col-span-3"}>{item.content_name}</p>
          <p className={"col-span-3"}>{item.content_description}</p>
          <p className={" col-span-1"}>{t(`OrderStatus.${item.status}`)}</p>
        </div>
      ))}
    </div>
  );
};

export default OrderMovieTable;
